export default __webpack_public_path__ + "static/media/moneyhand.102346c2.svg";